<div class="flex min-h-screen items-center justify-center px-4 py-8">
  <div class="flex w-full max-w-md flex-col gap-6">
    <app-logo [widthInPx]="120" />

    <div hlmCard>
      <div hlmCardHeader>
        <h1 hlmCardTitle>Passwort zurücksetzen</h1>
        <p hlmCardDescription>
          Gib deine E-Mail-Adresse ein und wir senden dir einen Link zum Zurücksetzen.
        </p>
      </div>

      <div hlmCardContent class="space-y-6">
        @if (success) {
          <!-- Deliberately vague: confirming which addresses exist would leak accounts -->
          <div hlmAlert>
            <ng-icon name="lucideMail" />
            <p hlmAlertTitle>E-Mail versendet</p>
            <p hlmAlertDescription>
              Wenn die E-Mail-Adresse existiert, wurde ein Link zum Zurücksetzen des Passworts
              versendet. Prüfe auch deinen Spam-Ordner.
            </p>
          </div>
        } @else {
          <form [formGroup]="resetForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-6">
            <div hlmField>
              <label hlmFieldLabel for="email">E-Mail</label>
              <input
                hlmInput
                id="email"
                type="email"
                inputmode="email"
                formControlName="email"
                autocomplete="email"
                placeholder="name@beispiel.de"
                class="w-full"
                [attr.aria-invalid]="submitted && f['email'].errors ? 'true' : null" />
              @if (submitted && f['email'].errors) {
                <p hlmFieldDescription class="text-destructive">
                  @if (f['email'].errors['required']) {
                    E-Mail ist erforderlich
                  } @else {
                    Bitte gib eine gültige E-Mail-Adresse ein
                  }
                </p>
              }
            </div>

            @if (error) {
              <div hlmAlert variant="destructive">
                <ng-icon name="lucideTriangleAlert" />
                <p hlmAlertTitle>{{ error }}</p>
              </div>
            }

            <button hlmBtn type="submit" class="w-full" [disabled]="loading">
              @if (loading) {
                <hlm-spinner />
                Wird gesendet…
              } @else {
                Link senden
              }
            </button>
          </form>
        }

        <p class="text-center text-sm">
          <a routerLink="/login" class="underline underline-offset-4">Zurück zum Login</a>
        </p>
      </div>
    </div>
  </div>
</div>
